/*
createNewSession.js
新的session模板
 */

import {createSessionID} from "../ID/createSessionID";
import {
    SUGGESTION_DEFAULT_VALUE_1,
    SUGGESTION_DEFAULT_VALUE_2,
    SUGGESTION_DEFAULT_VALUE_3,
    USER_KEY
} from "../../Common/constants";

export const createNewSession = () => {
    // 获取用户的ID
    let userID = sessionStorage.getItem(USER_KEY);
    const session = {
        sessionID: createSessionID({userID: userID}),
        title: '新会话',
        messages: [
            {
                id: 0,
                message: `**Hi,我是点五~** \n\n 我的设计来源于最小作用量和舒效比理论，一个总是开放的“帮助您，实现自己节能想法”的得力AI助手~`,
                status: 'success',
            },
        ],
        suggestions: [SUGGESTION_DEFAULT_VALUE_1, SUGGESTION_DEFAULT_VALUE_2, SUGGESTION_DEFAULT_VALUE_3],
    };

    return session;
}